import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { Faq, FaqContent, FaqItem, FaqValue, Group, KeypadOption, Title, UserList } from '../styles/dialpadstyle';
import {
  FormWrapper,
  FormColumn,
  FormGroup,
  ControlLabel,
  FormControl,
  Button
} from 'modules/theme';

export class FAQTheme extends Component {

  constructor(props) {
    super(props);
    this.open = this.open.bind(this);
    this.state = {
      isActive: false,
    };
  }

  open() {
    if (this.state.isActive) {
      this.setState({ isActive: false });
    } else {
      this.setState({ isActive: true });
    }

  }

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        {/* <ControlLabel required={props.required}>{label}</ControlLabel> */}
        <FormControl {...props} />
      </FormGroup>
    );
  }

  render() {
    const { title, search, btnSearch, q1, a1 } = this.props;
    return (
      <span style={{display: 'block', width: '100%'}}>
        <Title>
          {title}
        </Title>
        <Group>
          <form style={{ width: '88%' }}>
            <KeypadOption>
              <FormWrapper>
                {/* <FormColumn></FormColumn> */}
                <FormColumn>
                  {this.renderFormGroup('', {
                    defaultValue: '',
                    placeholder: 'Search...',
                    autoFocus: false,
                    required: true,
                    id: 'search',
                    value: '',
                    onChange: e => {
                      this.setState({ search: e.target.value });
                    }
                  })}
                </FormColumn>
              </FormWrapper>
            </KeypadOption>
            <Button
              btnStyle="link"
              type="simple"
              style={{ right: '-3px' }}
            >
              <img src={btnSearch} style={{ width: '38px' }} />
            </Button>
          </form>
        </Group>

        <UserList>
          <Faq onClick={() => this.open()}>
            <FaqItem>
              {q1}
            </FaqItem>
            <FaqValue>
              <img src="images/arrow-right-dark.svg" />
            </FaqValue>
          </Faq>
          {this.state.isActive &&
            <FaqContent>
              {a1}
            </FaqContent>
          }

          <Faq onClick={() => this.open()}>
            <FaqItem>
              {q1}
            </FaqItem>
            <FaqValue>
              <img src="images/arrow-right-dark.svg" />
            </FaqValue>
          </Faq>
          {this.state.isActive &&
            <FaqContent>
              {a1}
            </FaqContent>
          }
        </UserList>

        {/* <div className="accordion">
          <div className="accordion-item">
            <div
              className="accordion-title"
              onClick={() => this.open()}
            >
              <div>{q1}</div>
              <div>
                {this.state.isActive ? '-' : '+'}
              </div>
            </div>
            {this.state.isActive && <div className="accordion-content">{a1}</div>}
          </div>
        </div> */}
      </span >
    )
  }
}

FAQTheme.propTypes = {
};

FAQTheme.contextTypes = {
  __: PropTypes.func
};

export default FAQTheme


// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/FAQTheme.js